<template>
  <div v-loading="loading" class="body">
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <div v-if="!loading" class="resetPassword">
              <el-card>
                <el-row type="flex" class="row-bg" justify="end">
                  <LangSelector />
                </el-row>
                <div class="px-4 pb-3">
                  <div class="mainLogoPosition text-center">
                    <img
                      src="@/assets/gregorys_logo.png"
                      style="width: 200px"
                    />
                  </div>
                  <div class="reset-text">
                    <p>{{ $translation('b2b_forgot_pass_subtext') }}</p>
                    <p>{{ $translation('b2b_reset_pass_text') }}</p>
                  </div>
                  <el-form
                    ref="resetPassForm"
                    :model="resetPassForm"
                    :rules="resetPassRules"
                  >
                    <el-row :gutter="5">
                      <el-col :span="12" :xs="24">
                        <el-form-item
                          prop="password"
                          ref="password"
                          class="no-error-icon"
                          :label="this.$translation('b2b_select_pass')"
                        >
                          <el-input
                            :type="!passwordVisible ? 'password' : 'text'"
                            v-model="resetPassForm.password"
                            :placeholder="this.$translation('b2b_select_pass')"
                          >
                            <i
                              slot="suffix"
                              class="el-input__icon el-icon-view"
                              @click="togglePassVissible()"
                            ></i>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" :xs="24">
                        <el-form-item
                          prop="password2"
                          ref="password2"
                          class="no-error-icon"
                          :label="this.$translation('b2b_reenter_pass')"
                        >
                          <el-input
                            :type="!password2Visible ? 'password' : 'text'"
                            v-model="resetPassForm.password2"
                            :placeholder="this.$translation('b2b_reenter_pass')"
                          >
                            <i
                              slot="suffix"
                              class="el-input__icon el-icon-view"
                              @click="togglePass2Vissible()"
                            ></i>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <el-button
                    type="primary"
                    class="submitButton mt-4"
                    :disabled="!isValidForm"
                    @click="sendResetPassRequest"
                    >{{ $translation('b2b_save') }}</el-button
                  >
                  <p
                    class="text-center pointer resetText mt-4"
                    @click="$router.push('/')"
                  >
                    {{ this.$translation('b2b_back_to_login') }}
                  </p>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { isValidPassword } from '@/utils/validate';
import LangSelector from '@/components/LangSelector';
import { ResetPasswordApi } from '@/utils/echoApi';
export default {
  name: 'ResetPassword',
  components: {
    LangSelector
  },
  data() {
    const validateSelectPass = (rule, value, callback) => {
      if (this.$refs.password.fieldValue && !isValidPassword(value)) {
        this.validPasswords = false;
        this.showVerificationCode = false;
        callback(
          new Error(
            'Insert min length 8 chars, one uppercase, one digit, one special char'
          )
        );
      } else if (this.$refs.password2.fieldValue) {
        this.$refs.resetPassForm.validateField('password2');
        callback();
      } else {
        callback();
      }
    };
    const validateConfirmPass = (rule, value, callback) => {
      if (
        this.$refs.password2.fieldValue &&
        this.$refs.password.fieldValue &&
        this.resetPassForm.password !== this.resetPassForm.password2
      ) {
        this.validPasswords = false;
        this.showVerificationCode = false;
        callback(new Error('Passwords must match'));
      } else if (
        this.$refs.password.fieldValue &&
        !isValidPassword(this.$refs.password.fieldValue)
      ) {
        this.validPasswords = false;
        this.showVerificationCode = false;
        this.$refs.resetPassForm.validateField('selectPassword');
        callback();
      } else if (
        this.$refs.password2.fieldValue.length &&
        this.$refs.password.fieldValue.length
      ) {
        this.validPasswords = true;
        this.showVerificationCode = true;
        callback();
      } else if (
        !this.$refs.password2.fieldValue.length ||
        !this.$refs.password.fieldValue.length
      ) {
        this.validPasswords = false;
        this.showVerificationCode = false;
      }
    };
    return {
      passwordVisible: false,
      password2Visible: false,
      loading: true,
      resetPassForm: {
        password: '',
        password2: ''
      },
      resetPassRules: {
        password: [
          { required: true, trigger: 'change', validator: validateSelectPass }
        ],
        password2: [
          { required: true, trigger: 'change', validator: validateConfirmPass }
        ]
      }
    };
  },
  computed: {
    ...mapGetters('data', ['hostname']),
    ...mapState('data', {
      Translations: state => state.Translations
    }),
    isValidForm() {
      return (
        isValidPassword(this.resetPassForm.password) &&
        isValidPassword(this.resetPassForm.password2) &&
        this.resetPassForm.password === this.resetPassForm.password2
      );
    }
  },
  created() {
    let _this = this;
    _this.getTranslations().then(function() {
      setTimeout(function() {
        _this.loading = false;
      }, 1000);
    });
  },
  methods: {
    ...mapActions('data', ['getTranslations']),
    togglePassVissible() {
      this.passwordVisible = !this.passwordVisible;
    },
    togglePass2Vissible() {
      this.password2Visible = !this.password2Visible;
    },
    sendResetPassRequest() {
      this.$http
        .post(
          'https://' + this.hostname + ResetPasswordApi, // /auth/activate
          {
            hash: this.$route.params.hash,
            password: this.resetPassForm.password
          },
          { headers: { Accept: 'application/json' } }
        )
        .then(response => {
          this.$message({
            type: response.data.status,
            message: this.$translation(response.data.message)
          });
          this.$router.push('/');
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$translation(error.response.data.message)
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  background: url(../assets/images/main-image.jpg) center top / cover no-repeat;
  background-attachment: fixed;
  height: 100vh;
}

.resetPassword {
  display: block;
  margin: 15vh auto 0;
  width: 510px;
}

.reset-text {
  text-align: center;
}

.reset-text p:first-child {
  font-weight: 600;
  margin-top: 20px;
  font-size: 18px;
}

.resetOptionsList {
  padding: 0;
  margin: 30px 0 40px;
  list-style: none;
  display: flex;
  justify-content: center;
}

.resetOptionsList > li {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  font-size: 42px;
  height: 80px;
  width: 80px;
  background-color: #f4f4f4;
  border-radius: 40px;
  cursor: pointer;
  box-sizing: border-box;
}

.resetOptionsList > li.active {
  color: white;
  background-color: var(--main-color);
}

.el-input__icon {
  font-size: 22px;
  padding-left: 12px;
}

.submitButton {
  transition: all 0.3s ease-in-out;
  width: 100%;
}

.submitButton.is-disabled {
  background-color: gray !important;
}

@media (max-width: 530px) {
  .resetPassword {
    margin: 0 auto;
    width: 400px;
  }
}
@media (max-width: 435px) {
  .resetPassword {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue